<template>
    <div class="dynamic-display">
        <div v-if="isLoading" class="px-4 py-2 text-center text-gray">Loading</div>
        <div v-if="errorLoading" class="px-4 py-2 text-center text-gray">There was something not right while loading data</div>
        <template v-if="showingResults">
            <slot name="showResultsContainer"></slot>
        </template>
    </div>
</template>

<script>
    export default {
        name: "DynamicDisplay",
        data() {
            return {
                isLoading: false,
                showingResults: false,
                errorLoading: false,
                results: null,
            }
        },
        props: {
            loadDataApi: Function,
            loadDataOnCreated: {
                default: true,
            }
        },
        methods: {
            loadData() {
                if (this.isLoading) {
                    return;
                }
                this.setLoadingStatus(true, false, false);
                this.loadDataApi().then(r => {
                    this.results = r.data;
                    this.setLoadingStatus(false, true, false);
                }).catch(() => {
                    this.setLoadingStatus(false, false, true)
                }).always(()=>{
                    this.$emit('loadEnd', this.showingResults, this.results);
                })
            },
            setLoadingStatus(isLoading, showingResults, errorLoading) {
                this.isLoading = isLoading;
                this.showingResults = showingResults;
                this.errorLoading = errorLoading;

                this.$emit('statusChanged');
            },
        },
        created() {
            if (this.loadDataOnCreated) {
                this.loadData();
            }
        }
    }
</script>

<style scoped>

</style>
